export const formatAA = async (licenceDetails: any, _caseTypeID: string, _application?: string) => {
    // AA Licence View - Registration of Accounting Authority
    // licenceDetails = content.LICApplication.licence
    // Replicates the same field mapping as AA application-details form
    
    // Read from licence.additionalInfo according to correct backend contract
    const licenceNode = licenceDetails || {};
    const additionalInfoNode = licenceNode.additionalInfo || {};
    
    // Normalise ship registration data from additionalInfo.registeredShipList
    const shipDataRaw: any[] = additionalInfoNode.registeredShipList || [];
    const mappedShipData = (Array.isArray(shipDataRaw) ? shipDataRaw : [])
        .map((ship: any) => {
            return {
                shipName: ship.shipName || '',
                callSign: ship.callSign || '',
                licenceNo: ship.licenceNo || '',
                aaicCode: ship.aaicCode || '',
                mmsiNo: ship.mmsiNo || ''
            };
        })
        // Drop rows that are completely empty
        .filter(ship => Object.values(ship).some(v => v !== '' && v !== undefined && v !== null));

    const applicationDetailsValues = {
        // Licence name (fallback to static if backend omits)
        'application-details-licence-name': licenceDetails?.licenceName || 'Registration of Accounting Authority',
        // AA-specific fields from additionalInfo
        'capital-details-company-paid-up-capital': additionalInfoNode.companyPaidUpCapital || '',
        'registered-ship-information-submission-method': additionalInfoNode.submissionMethod || '',
        'registered-ship-information-aaic-code': additionalInfoNode.aaicCode || '',
        'registered-ship-information-scheme-of-service': additionalInfoNode.serviceTermsAndFees || '',
        // Ship registration data
        'registered-ship-information-list-registered-ships': mappedShipData
    };

    const licence = {
        id: 'application-details',
        formID: 'application-details',
        hasError: false,
        title: 'Licence Details',
        values: applicationDetailsValues
    };

    return licence;
};

const aaPayload = {
    formatAA
};

export default aaPayload;
